export const fmtDate = (iso: string) => new Date(`${iso}T12:00:00`).toLocaleDateString("nl-NL");
const telHref = (n: string) => `tel:${n.replace(/[^\d+]/g, "")}`;

/** Telefoonnummer als belknop (tel:-link). */
export function Phone({ n, label }: { n: string | null; label?: string }) {
  if (!n) return null;
  return (
    <a className="dir-tel num" href={telHref(n)} aria-label={label ? `${label} ${n}` : undefined}>
      {n}
    </a>
  );
}

export const COMPANY_TABS = [
  "overzicht",
  "inzichten",
  "werk",
  "contracten",
  "documenten",
  "gebouwen",
  "personen",
  "logboek",
] as const;
export type CompanyTab = (typeof COMPANY_TABS)[number];

/** Adres van de bedrijfspagina (premium adresboek), eventueel op een tabblad. */
export const companyPath = (id: string, tab?: CompanyTab) =>
  `/adresboek/bedrijf/${id}${tab && tab !== "overzicht" ? `?tab=${tab}` : ""}`;
